<template>
  <div class="chat-avatar" @click="goCharacterDetail">
    <img :src="url" alt="" class="avatar-img">
  </div>
</template>

<script>
export default {
  name: 'Avatar',
  props: {
    url: String,
  },
  methods: {
    goCharacterDetail() {
      this.$emit('goCharacterDetail');
    },
  },
};
</script>

<style lang="less" scoped>
.chat-avatar {
  width: 44px;
  height: 44px;
  margin-right: 14px;
  border-radius: 50%;
  overflow: hidden;
  .avatar-img {
    width: 100%;
    height: 100%;
    vertical-align: middle;
  }
}
</style>
